var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondBackgroundOverlap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 737,
    viewBox: "0 0 504 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.12 492.445L492.404 245.821L343.498 245.653C330.78 245.639 318.19 243.119 306.446 238.239C294.702 233.359 284.035 226.213 275.052 217.21C264.802 206.901 256.994 194.424 252.205 180.697C247.416 166.97 245.767 152.344 247.38 137.896C247.853 133.57 248.101 129.222 248.122 124.871C248.417 57.7816 193.078 1.64893 126.018 1.00579C57.0692 0.345268 0.994536 56.2926 1.50441 125.242C1.9969 192.325 58.002 247.768 125.091 247.623C129.401 247.611 133.708 247.379 137.995 246.928C152.488 245.345 167.153 247.031 180.909 251.863C194.665 256.695 207.163 264.55 217.483 274.85L217.894 275.261C235.724 293.124 245.728 317.338 245.706 342.576L245.596 441.214C245.575 456.868 239.339 471.873 228.26 482.931L227.831 483.36C219.872 491.264 209.831 496.745 198.878 499.163C187.924 501.58 176.509 500.836 165.962 497.016C152.321 492.13 137.924 489.688 123.434 489.803C55.8757 490.272 1.12773 545.31 1.00026 612.868C0.861205 681.047 56.0899 736.403 124.274 736.426C191.833 736.426 246.992 681.823 247.612 614.27C247.764 599.78 245.356 585.377 240.497 571.725C236.702 561.168 235.984 549.751 238.427 538.803C240.871 527.854 246.375 517.826 254.298 509.885L254.565 509.624C265.755 498.47 280.917 492.218 296.716 492.242L492.12 492.445Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.554,
    cy: 207.379,
    rx: 11.491,
    ry: 11.491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.356,
    cy: 462.02,
    rx: 11.491,
    ry: 11.491,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.298,
    cy: 703.791,
    rx: 11.491,
    ry: 11.491,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBackgroundOverlap);
export default __webpack_public_path__ + "static/media/second-background-overlap.d9bdf0a9.svg";
export { ForwardRef as ReactComponent };